import usePageInfo from '../hooks/usePageInfo';

const withPageInfo = <Props extends { pageInfo: { [key: string]: string } }>(
  Component: React.ComponentType<Props>
) => (props: Props) => {
  const pageInfo = usePageInfo();
  return <Component {...props} pageInfo={pageInfo} />;
};

export default withPageInfo;
